import { UseMutationResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { IGoogle2faSecretResponse } from 'core/types/models/google2faType';
import { useDispatch } from 'react-redux';

export const useGoogle2FASecretQuery = () => {
	const dispatch = useDispatch();

	return useMutationHook(
		[endPointUrls.GENERATE2FA_SECRET],
		(data) => api.post(endPointUrls.GENERATE2FA_SECRET, data),
		{
			onSuccess: (res: any) => {
				if (res?.status === 200) {
					toastHandler('success', res?.data.message);
					dispatch(setApiCatcherFormErrors([]));
				}
			},
		}
	) as UseMutationResult<IGoogle2faSecretResponse, Error>;
};
